import { createCRUDConstants } from "../../../utils/redux.utils";

export const nameSpace = "SCPISSUERCONFIG";
export const scpIssuerConstants = createCRUDConstants(nameSpace);
